import React, { useEffect } from 'react';

import { useConfluenceAnalyticsEvents } from '@confluence/analytics/entry-points/useConfluenceAnalyticsEvents.ts';

import { SearchAcrossToolsItem } from '../components/SearchAcrossToolsItem.tsx';
import { useConnectorPromoConfig } from '../hooks/useConnectorPromoConfig.ts';

/**
 * Self-contained surface component for the sidebar.
 * Internally calls useConnectorPromoConfig and renders the SearchAcrossToolsItem.
 * Clicking "Setup" on a connector calls onSetupConnector, which updates the
 * shared setup-connector store; the modal itself is rendered by the
 * always-mounted ConnectorSetupModalHost, not here.
 */
export function ConnectorPromoSidebar({
	isSidebarCollapsed,
}: {
	isSidebarCollapsed?: boolean;
}): React.JSX.Element | null {
	const config = useConnectorPromoConfig();
	const { createEvent } = useConfluenceAnalyticsEvents();

	useEffect(() => {
		if (!config.shouldShowSidebarItem) {
			return;
		}
		createEvent({
			type: 'sendTrackEvent',
			data: {
				source: 'ConnectorPromoSidebar',
				action: 'viewed',
				actionSubject: 'connectorPromo',
				attributes: {
					promoVariant: 'sidebarItem',
					container: 'ConnectorPromoSidebar',
				},
			},
		}).fire();
	}, [config.shouldShowSidebarItem, createEvent]);

	if (!config.shouldShowSidebarItem) {
		return null;
	}

	return (
		<SearchAcrossToolsItem
			recommendedConnectors={config.recommendedConnectors}
			onSetupConnector={config.onSetupConnector}
			onDismiss={() => config.onDismissPromo('sidebar')}
			shouldShowSpotlight={config.shouldShowSpotlight}
			onDismissSpotlight={config.onDismissSpotlight}
			isSidebarCollapsed={isSidebarCollapsed}
		/>
	);
}
